import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import type {
  ContactMessagePayload,
  SpeakerRequestPayload,
} from '@app/interfaces/public/contact-message.interfaces';

export type {
  ContactMessagePayload,
  SpeakerRequestPayload,
} from '@app/interfaces/public/contact-message.interfaces';

@Injectable({ providedIn: 'root' })
export class ContactMessageService {
  private readonly contactMessagesUrl = `${environment.apiUrl}/public/contact/messages`;
  private readonly speakerRequestsUrl = `${environment.apiUrl}/public/speaker-requests`;
  private readonly newsletterUrl = `${environment.apiUrl}/public/newsletter`;

  constructor(private http: HttpClient) {}

  // Sends public contact form data to backend email endpoint.
  sendMessage(payload: ContactMessagePayload): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(this.contactMessagesUrl, payload);
  }

  // Sends speaker request form data to backend endpoint.
  sendSpeakerRequest(payload: SpeakerRequestPayload): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(this.speakerRequestsUrl, payload);
  }

  subscribeNewsletter(email: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.newsletterUrl}/subscribe`, { email });
  }
}
